import React, { Component } from 'react';
import Joyride, { CallBackProps, STATUS, Step, StoreHelpers } from 'react-joyride';
import {Typography} from "@material-ui/core";

interface Props {
    breakpoint: string;
    translate: any;
    skipOrEndCallback: () => void;
}

interface State {
    run: boolean;
    steps: Step[];
}

class HomeTutorialXs extends Component<Props, State> {
    private helpers?: StoreHelpers;
    private skipOrEndCallback: any;

    constructor(props: Props) {
        super(props);

        const { translate, skipOrEndCallback} = props;
        this.skipOrEndCallback = skipOrEndCallback;

        this.state = {
            run: true,
            steps: [
                {
                    content:<>
                        <Typography variant={"h1"} component={"p"} color={"secondary"}>{translate("tutorial.homeTutorial.title.step0")}</Typography>
                        <br/>
                        <Typography component={"p"}>{translate("tutorial.homeTutorial.message.step0")}</Typography>
                    </>
                    ,
                    disableBeacon: true,
                    locale: { back: 'Previous', close: 'Close', last: 'Close', next: 'Next', open: 'Open the dialog', skip: 'Skip tutorial' },
                    floaterProps: {
                        disableAnimation: true,
                    },
                    spotlightPadding: 10,
                    placement: 'center',
                    target: '.joyrideHomeXs00',
                },{
                    content:<>
                        <Typography variant={"h1"} component={"p"} color={"secondary"}>{translate("tutorial.homeTutorial.title.step1")}</Typography>
                        <br/>
                        <Typography component={"p"}>{translate("tutorial.homeTutorial.message.step1")}</Typography>
                        </>
                    ,
                    disableBeacon: true,
                    locale: { back: 'Previous', close: 'Close', last: 'Close', next: 'Next', open: 'Open the dialog', skip: 'Skip tutorial' },
                    floaterProps: {
                        disableAnimation: true,
                    },
                    spotlightPadding: 0,
                    placement: 'top',
                    target: '.joyrideHomeXs01',
                },
                {
                    content:<>
                        <Typography variant={"h1"} component={"p"} color={"secondary"}>{translate("tutorial.homeTutorial.title.step2")}</Typography>
                        <br/>
                        <Typography component={"p"}>{translate("tutorial.homeTutorial.message.step2")}</Typography>
                        </>
                    ,
                    disableBeacon: true,
                    locale: { back: 'Previous', close: 'Close', last: 'Close', next: 'Next', open: 'Open the dialog', skip: 'Skip tutorial' },
                    floaterProps: {
                        disableAnimation: true,
                    },
                    spotlightPadding: 0,
                    placement: 'bottom',
                    target: '.joyrideHomeXs02',
                },
                {
                    content:<>
                        <Typography variant={"h1"} component={"p"} color={"secondary"}>{translate("tutorial.homeTutorial.title.step3")}</Typography>
                        <br/>
                        <Typography component={"p"}>{translate("tutorial.homeTutorial.message.step3")}</Typography>
                        </>
                    ,
                    disableBeacon: true,
                    locale: { back: 'Previous', close: 'Close', last: 'Close', next: 'Next', open: 'Open the dialog', skip: 'Skip tutorial' },
                    floaterProps: {
                        disableAnimation: true,
                    },
                    spotlightPadding: 0,
                    placement: 'bottom',
                    target: '.joyrideHomeXs03',
                },
                {
                    content:<>
                        <Typography variant={"h1"} component={"p"} color={"secondary"}>{translate("tutorial.homeTutorial.title.step4")}</Typography>
                        <br/>
                        <Typography component={"p"}>{translate("tutorial.homeTutorial.message.step4")}</Typography>
                        </>
                    ,
                    disableBeacon: true,
                    locale: { back: 'Previous', close: 'Close', last: 'Close', next: 'Next', open: 'Open the dialog', skip: 'Skip tutorial' },
                    floaterProps: {
                        disableAnimation: true,
                    },
                    spotlightPadding: 0,
                    placement: 'bottom',
                    target: '.joyrideHomeXs04',
                }
            ],
        };
    }

    private getHelpers = (helpers: StoreHelpers) => {
        this.helpers = helpers;
    };

    private handleClickStart = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        this.setState({
            run: true,
        });
    };

    private handleJoyrideCallback = (data: CallBackProps) => {
        const { status, type } = data;
        const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({ run: false });
            this.skipOrEndCallback();
        }

        console.groupCollapsed(type);
        console.log(data);
        console.groupEnd();
    };

    public render() {
        const { run, steps } = this.state;
        const { breakpoint } = this.props;

        return (
            <Joyride
                callback={this.handleJoyrideCallback}
                continuous={true}
                getHelpers={this.getHelpers}
                run={run}
                disableScrolling={true}
                disableOverlayClose={true}
                scrollToFirstStep={false}
                showProgress={true}
                showSkipButton={true}
                steps={steps}
                styles={{
                    options: {
                        arrowColor: 'transparent',
                        backgroundColor: 'transparent',
                        primaryColor: '#f4cc47',
                        textColor: '#FFF',
                        overlayColor: 'rgba(0, 0, 0, 0.8)',
                        spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
                        zIndex: 10000,
                    },
                }}
            />
        );
    }
}

export default HomeTutorialXs;
